import { render, staticRenderFns } from "./Dottore.vue?vue&type=template&id=7dae3525&scoped=true&"
import script from "./Dottore.vue?vue&type=script&lang=js&"
export * from "./Dottore.vue?vue&type=script&lang=js&"
import style0 from "./Dottore.vue?vue&type=style&index=0&id=7dae3525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dae3525",
  null
  
)

export default component.exports